export interface BillingInfo {
  currentPlan: {
    name: string;
    includedCredits: number;
    creditLimit: number | null;
    proxyBandwidthMb: number;
  };
  usage: {
    creditsUsed: number;
    creditsRemaining: number | null;
    additionalCredits: number;
    additionalCreditsExpiresAt: string | null;
    billingCycleStart: string | null;
    proxyUsedMb: number;
    proxyRemainingMb: number;
    additionalProxyMb: number;
    additionalProxyExpiresAt: string | null;
  };
  subscription: {
    status: string;
    startedAt: string;
    renewsAt: string | null;
    cancelAtPeriodEnd: boolean;
    nextAmountCents: number | null;
    currency: string | null;
    pendingPlan: { name: string; effectiveAt: string } | null;
  } | null;
  paymentMethod: { brand: string; last4: string; expMonth: number; expYear: number } | null;
  invoices: Array<{
    id: string;
    number: string | null;
    date: string;
    amountCents: number;
    currency: string;
    status: string | null;
    url: string | null;
    pdf: string | null;
  }>;
}

export const PLAN_ORDER = ["Free", "Starter", "Builder", "Pro"] as const;
export const planRank = (name: string) => PLAN_ORDER.indexOf(name as (typeof PLAN_ORDER)[number]);
